export default __webpack_public_path__ + "static/media/dark3.1099a23c.jpg";